import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import {Sabko} from '../App';
import '../style/Formcom.css';

function Objective() {
  const navigate=useNavigate();
  const {state,dispatch}=useContext(Sabko);
  const[Objecti,setObjecti]=useState(null)

  const submitPersoal=(e)=>{
    e.preventDefault();
    if(Objecti===""){
      navigate('/');
    }else{
      dispatch({type:"OBJECTIVE_DETAIL",payload:{Objective:((state.User?.Objective))||(Objecti)}});
      navigate('/');
    }
  }
  return (
    <>
    <div className='main'>
        <form className='Homediv'>
        <div className='inputdiv'>
            <label htmlFor='name' className='inputLabel'>Objective</label>
            <textarea rows='7' cols='7' id='name' name='address'  
             value={(Objecti)||((Objecti==="")?(""):(state.User?.Objective) || (""))} 
             className='inputContent' style={{border: '1px solid gray'}}  
             onChange={(e)=>setObjecti(e.target.value)}/>
            </div>


            <div className='saveDiv'>
            <Button variant="contained" type='submit' className='saveButt' onClick={submitPersoal}>
            Save</Button>
            </div>
           
        </form>
    </div>
    </>
  )
}

export default Objective